import { render, staticRenderFns } from "./Command.vue?vue&type=template&id=59577bc3&"
import script from "./Command.vue?vue&type=script&lang=js&"
export * from "./Command.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports